import _ from 'lodash';
import { useLayoutEffect } from 'react';
import { findBrokerConfigById } from './config';
import { useLoginContext } from './LoginProvider';
import { ACTIVE_BROKERS_DOMAINS } from '../../types.type';
import { Nullable } from './types.type';

export const useLoginModal = (
  goToCredentialPhase: boolean,
  hideLoginModal: () => void,
  preSelectedBrokerId: Nullable<ACTIVE_BROKERS_DOMAINS>
) => {
  const { onPartialStateUpdate } = useLoginContext();

  // This is Used Here Before the DOM paints the config has to be updated on the state
  useLayoutEffect(() => {
    if (goToCredentialPhase) {
      // Debpunce used here for the filtration logic to be run
      // Up until the filteration goes, the delay is added
      // This is added due to flicker issues in background
      _.debounce(
        () =>
          onPartialStateUpdate({
            selectedBrokerConfig: findBrokerConfigById(preSelectedBrokerId as ACTIVE_BROKERS_DOMAINS),
            currentPageIndex: 1,
          }),
        50
      )();
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        hideLoginModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
